import { connect } from 'react-redux';
import viewDropdown from '../components/toolbar/view-dropdown';
import { updateView, updateWorklistViews } from './worklist-actions';

const mapStateToProps = state => ({
  views: state.worklist.views,
  activeView: state.worklist.activeView,
  isLoadingViews: state.worklist.isLoadingViews,
  isSavingViews: state.worklist.isSavingViews,
  activeSort: state.worklist.activeSort,
  activeFilters: state.worklist.activeFilters,
  defaultExpanded: state.worklist.defaultExpanded,
});

const mapDispatchToProps = {
  updateView,
  updateViews: updateWorklistViews,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(viewDropdown);
